import { render, staticRenderFns } from "./RawMaterialCategories.vue?vue&type=template&id=1b3d5e51"
import script from "./RawMaterialCategories.vue?vue&type=script&lang=js"
export * from "./RawMaterialCategories.vue?vue&type=script&lang=js"
import style0 from "./RawMaterialCategories.vue?vue&type=style&index=0&id=1b3d5e51&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports